import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowDownMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.5 10.18V3q0-.42.29-.71A1 1 0 0 1 8.5 2a.97.97 0 0 1 1 1v7.18l2.9-2.9a1 1 0 0 1 .7-.28q.43 0 .7.28a1 1 0 0 1 .27.7 1 1 0 0 1-.27.7l-4.6 4.6q-.3.3-.7.3a1 1 0 0 1-.7-.3l-4.6-4.6a1 1 0 0 1-.28-.7q0-.43.28-.7A1 1 0 0 1 3.9 7q.43 0 .7.28z" />
  </svg>
)
export default SvgArrowDownMini
